import tote from "../assets/SOWS tote.webp";
import sweater from "../assets/SOWS Sweater.webp";
import shirt from "../assets/SOWshirt.webp";

export default function Donate() {
  const donationLink =
    "https://leonardeducation.org/the-seeds-of-a-watermelon-scholarship-fund/";

  const rewards = [
    {
      price: "$15",
      label: "FREE Tote",
      image: tote,
    },
    {
      price: "$25",
      label: "FREE Shirt",
      image: shirt,
    },
    {
      price: "$35",
      label: "FREE Sweater",
      image: sweater,
    },
  ];

  return (
    <div className="donate-page">
      <h1 className="donate-title">Donate</h1>

      {/* INFO BOX */}
      <div className="info-box">
        <p>
          If you would like to donate to this fund you can do so by any of the
          options below:
        </p>
        <ol>
          <li>
            Sending a check payable to "Leonard Education Organization" with "The Seeds of a Watermelon Scholarship Fund" in the memo field, to this address (this option is preferred to minimize processing fees): PO Box 11283 NW, Washington DC 20008.
          </li>
          <li>
            Paying by wire transfer, please email us at info@leonardeducation.org to request the bank account details
          </li>
          <li>
            Paying using the donation form below (we accept all major credit/debit cards, Venmo, PayPal, Apple Pay, Google Pay, ACH (for US))
          </li>
        </ol>
      </div>

      {/* GENERAL DONATE BUTTON */}
      <div style={{ textAlign: "center", margin: "40px 0" }}>
        <a
          href={donationLink}
          target="_blank"
          rel="noopener noreferrer"
          className="donate-button"
        style={{ fontSize: "20px", padding: "16px 48px", display: "inline-block" }}
        >
          Donate Now
        </a>
      </div>

      {/* PRIZES SECTION */}
      <div className="prizes-container">
        <h2>Donation Rewards</h2>

        <div className="card-grid">
          {rewards.map((reward, index) => (
            <div key={index} className="donation-card">
              <div style={{ width: "100%", height: "280px", overflow: "hidden", borderRadius: "8px 8px 0 0" }}>
                <img
                  src={reward.image}
                  alt={reward.label}
                  style={{ width: "100%", height: "100%", objectFit: "contain", backgroundColor: "#f5f0e8" }}
                />
              </div>

              <div className="card-content">
                <h3>{reward.price}</h3>
                <p>{reward.label}</p>
              </div>

              <a
                href={donationLink}
                target="_blank"
                rel="noopener noreferrer"
                className="donate-button"
              >
                Donate {reward.price}
              </a>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
}